import './App.css';
import { useEffect, useState } from 'react';
import Box from '@mui/material/Box';
import de from "javascript-time-ago/locale/de";
import TimeAgo from "javascript-time-ago";
import { Button, Stack, Typography } from '@mui/material';
import { useNavigate } from 'react-router';

function App(params) {
  const navigate = useNavigate();
  const [auth, setAuth] = useState(false);
  useEffect(() => {
    TimeAgo.setDefaultLocale(de.locale);
    TimeAgo.addLocale(de);
    fetch('/api/loggedIn')
      .then(res => res.json())
      .then(r => setAuth(r))
      .catch(e => console.error(e));
  }, []);

  return (
    <div>
      <div style={{justifyContent: 'center', display: 'flex'}}>
        <Box sx={{ flexGrow: 1, justifyContent: 'center', alignItems: 'center', display:'flex', flexDirection: 'column'}} className="booking-table-container">
          <h2 align='center'>Fritti Wiki</h2>
          <Typography variant='body1' sx={{margin: '10px'}}><p>Fritti Wiki hilft, die richtigen Einstellungen in der Heißluftfritteuse für dein Gericht zu finden.<br/>
            Heißluftfritteusen unterscheiden sich untereinander, so wie die Vorlieben von Personen.<br/>
            Fritti Wiki berücksichtigt die Eigenheiten der Heißluftfritteuse sowie die persönlichen Vorlieben, um eine Empfehlung für ein Gericht bereitzustellen.</p>
            <p>Wie funktioniert's?<br/>
            Aus den Erfahrungen aller Userinnen und User wird ein Rezept erstellt.<br/>
            Dabei wird der Einfluss der jeweiligen Heißluftfritteusen bestimmt.<br/>
            Anschließend wird deine persönliche Vorliebe ermittelt.<br/>
            Mit diesen Daten kann eine Empfehlung für alte und neue Gerichte erstellt werden.</p>
            <p>Ein Erfahrungsbericht besteht aus Einstellung (Temperatur, Dauer) und dem Ergebnis: Wie ist die (innere) Krossheit/Garheit?</p>
          </Typography>
          {auth && <Stack direction='column' sx={{justifyContent: 'flex-start', alignItems: 'flex-start'}}>
            <Typography variant='body1'>
              Im Profil kann die Heißluftfritteuse konfiguriert werden.
            </Typography>
            <Button className='custom-button-root'
              onClick={() => navigate('/user')}>
                Profil
            </Button>
            <Typography variant='body1'>
              Die auf der Plattform erfassten Produkte sind hier zu finden:
            </Typography>
            <Button className='custom-button-root'
              onClick={() => navigate('/product')}>
                Produkte
            </Button>
            <Typography variant='body1'>
              Deine bereits erfassten Erfahrungsberichte findest du hier. Du kannst neue hinzufügen und alte editieren.
            </Typography>
            <Button className='custom-button-root'
              onClick={() => navigate('/report')}>
                Erfahrungsberichte
            </Button>
          </Stack>}
          <img src='/struktur.png' style={{maxWidth: '80%', minWidth: '200px'}} alt='Bild zur Funktionsbeschreibung'/>
        </Box>
      </div>
    </div>
  );
}

export default App;
